// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"b77694d8","667":"3586bb3d"}[chunkId] + ".chunk.js";
};